import React from "react"
import { NavLink } from "react-router-dom";
import LeitnerBoxState, { LeitnerBoxProps } from "./LeitnerBox.models";
import './LeitnerBox.scss';

export default class LeitnerBox extends React.PureComponent<LeitnerBoxProps, LeitnerBoxState> {
    constructor(props: LeitnerBoxProps) {
        super(props);
        this.state = {};

    }

    render(): React.ReactNode {
        let { boxDetail } = this.props;
        let boxStyle = { backgroundImage: `url(${boxDetail.imageSource})` };
        return <>
            <NavLink to={boxDetail.redirectLink}>
                <div className="row leitner-box-area">
                    <div className="col-12" >
                        <div className="box-area image-box-content" style={boxStyle}>
                            <label>{boxDetail.title}</label>
                        </div>
                    </div>
                </div>
            </NavLink>
        </>;
    }
}